import { Mapper } from "../../../../base/utils/mapper";
import { ProductModel } from "../../../../domain/models/comercial/product.model";
import { ProductEntity } from "../entities/product.entity";

export class ProductImplementationRepositoryMapper extends Mapper<ProductEntity, ProductModel> {
    mapFrom(param: ProductEntity): ProductModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ProductModel): ProductEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}
